import { useMemo } from "react";

import PropTypes from "prop-types";

import { apiOutletClient } from "@/features/shared";

import { ProductSelectBase } from "./product-select-base";

// Outlet-scoped product picker — lists the products of a SPECIFIC outlet.
// `outletId` MUST be the form's outlet (seller / buyer / outlet field), never
// left to the ambient global outlet: the product list feeds saved transaction
// lines, so it has to match the outlet the transaction is saved for. Use in
// transaction forms; for org-level screens use the global ProductSelect.
export const OutletProductSelect = ({ outletId, ...props }) => {
  if (import.meta.env.DEV && !outletId) {
    console.warn(
      "[OutletProductSelect] missing `outletId`: the product list falls back to the tab's active outlet instead of the form's outlet. Pass the form's seller/buyer/outlet id.",
    );
  }

  const requestConfig = useMemo(
    () => (outletId ? { headers: { "Outlet-Id": outletId } } : undefined),
    [outletId],
  );

  return (
    <ProductSelectBase
      client={apiOutletClient}
      requestConfig={requestConfig}
      {...props}
    />
  );
};

OutletProductSelect.propTypes = {
  outletId: PropTypes.string,
};
